import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import TooltipNew from 'src/App/Dashboards/Market/Components/Tooltips/TooltipNew';
import { COLOR_GREY_200, COLOR_PRIMARY_2, COLOR_SUCCESS, COLOR_TEXT_2 } from 'src/utils/colors';
import { getGradeColor, getGradeAGradient } from 'src/utils/functions';
import LockIcon from '@mui/icons-material/Lock';
import { getMarketGradeTooltip, NoteText } from './TooltipText';

const LockIconComponent = (
  <LockIcon sx={{ color: COLOR_PRIMARY_2, fontSize: '16px', transform: 'translateY(2px)' }} />
);

const SubmarketMarketGrade = ({
  neighborhoodGrade,
  isSubmarketAccessAllowed,
  handleOnSampleClick,
  marketGradeSx,
  verifiedTier,
}: {
  neighborhoodGrade: string;
  isSubmarketAccessAllowed: boolean;
  handleOnSampleClick: (plan: string) => void;
  marketGradeSx?: any;
  verifiedTier?: string;
}) => {
  const isCustomMarket = verifiedTier?.toUpperCase() === 'C';
  const isGradeA = neighborhoodGrade?.toUpperCase().startsWith('A');

  const getTooltipContent = () => {
    if (isCustomMarket) {
      return (
        <>
          Custom markets currently do not support neighborhood grades. Neighborhood grades are only available for verified standard markets.
          <br />
          <br />
          <strong>Note:</strong> Some older custom markets may display neighborhood grades from historical data.
        </>
      );
    }

    if (isSubmarketAccessAllowed) {
      return getMarketGradeTooltip(neighborhoodGrade);
    }

    return (
      <>
        This neighborhood ranks in the top {LockIconComponent} of the market, earning{' '}
        {LockIconComponent} premium over the average.
        {NoteText}
      </>
    );
  };

  return (
    <>
      <TooltipNew title="" content={getTooltipContent()}>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '30px',
            width: '30px',
            minWidth: '30px',
            minHeight: '30px',
            borderRadius: '900px',
            border: isSubmarketAccessAllowed ? '3px solid' : '1px solid',
            borderColor: !isSubmarketAccessAllowed
              ? COLOR_SUCCESS
              : neighborhoodGrade
              ? getGradeColor(neighborhoodGrade)
              : COLOR_GREY_200,
            mr: 1,
            backgroundColor: '#fff',
            ...(!isSubmarketAccessAllowed && {
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '150%',
                height: '150%',
                transform: 'translate(-18%, -18%)',
                borderRadius: '900px',
                backgroundColor: '#fff5',
                backdropFilter: 'blur(1.5px)',
              },
            }),
          }}
        >
          <Typography 
            sx={{ 
              color: isGradeA && isSubmarketAccessAllowed ? undefined : COLOR_TEXT_2, 
              fontWeight: 500, 
              cursor: 'default',
              ...(isGradeA && isSubmarketAccessAllowed && getGradeAGradient()),
            }}
          >
            {isSubmarketAccessAllowed ? (
              neighborhoodGrade || ''
            ) : (
              <IconButton onClick={() => handleOnSampleClick('expert')}>
                <LockIcon sx={{ color: COLOR_PRIMARY_2 }} />
              </IconButton>
            )}
          </Typography>
        </Box>
      </TooltipNew>
    </>
  );
};

export default SubmarketMarketGrade;
